// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3bObD","left":"styles_left__2PWIa"};